import React from 'react';
import { styled } from '@compiled/react';
import EditorPanelIcon from '@atlaskit/icon/core/migration/information--editor-panel';
import EditorWarningIcon from '@atlaskit/icon/core/migration/warning--editor-warning';
import { token } from '@atlaskit/tokens';

export type EditPanelMessage = {
	label: 'warning' | 'info';
	messageContent: string;
};

export type Props = {
	messages: EditPanelMessage[];
};

export const EditMessage = (props: Props) => {
	const renderMessage = (message: EditPanelMessage, index: number) => {
		switch (message.label) {
			case 'warning':
				return (
					<MessageContainer key={index}>
						<EditorWarningIcon
							spacing="spacious"
							label="warning"
							color={token('color.icon.warning')}
						/>
						<Message>{message.messageContent}</Message>
					</MessageContainer>
				);

			case 'info':
				return (
					<MessageContainer key={index}>
						<EditorPanelIcon spacing="spacious" label="info" />
						<Message>{message.messageContent}</Message>
					</MessageContainer>
				);
			default:
				return undefined;
		}
	};

	return <>{props.messages.map(renderMessage)}</>;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const MessageContainer = styled.div({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle'),
	display: 'flex',
	alignItems: 'center',
	font: token('font.body.small'),
	// eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
	lineHeight: 1.33333333333333,
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Message = styled.span({
	marginLeft: token('space.050'),
});
